import { type PermissionProjectPermissions } from "../../SettingsPermissions/types/permissions.types.ts"
import { invoicesHiddenForRole } from "../../../utils/invoices-visibility.ts"
import { canViewFinanceTab } from "./project-finance-visibility.ts"

export type ProjectSectionKeys =
  | "milestones"
  | "finance"
  | "invoices"
  | "tasks"
  | "commissions"
  | "albums"
  | "logs"

export const PROJECT_TAB_ORDER: ProjectSectionKeys[] = [
  "milestones",
  "finance",
  "invoices",
  "tasks",
  "commissions",
  "albums",
  "logs"
]

export const getVisibleProjectTabs = (
  permissions: PermissionProjectPermissions | undefined,
  roleId?: number | null
): ProjectSectionKeys[] => {
  const visibility: Record<ProjectSectionKeys, boolean> = {
    milestones: !!permissions?.milestones?.project_milestone_view,
    finance: canViewFinanceTab(permissions),
    invoices:
      !!permissions?.invoices?.project_invoice_view &&
      !invoicesHiddenForRole(roleId),
    tasks: !!permissions?.checklists?.project_checklist_view,
    commissions: !!permissions?.commissions?.project_commission_view,
    albums: !!permissions?.docs?.project_doc_view,
    logs: !!permissions?.features?.project_activity_log
  }

  return PROJECT_TAB_ORDER.filter((tab) => visibility[tab])
}
